import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array } from "../../../shared/src/codecs/types/array";
import { boolean } from "../../../shared/src/codecs/types/boolean";
import { date } from "../../../shared/src/codecs/types/date";
import { form } from "../../../shared/src/codecs/types/form";
import { literal } from "../../../shared/src/codecs/types/literal";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { positiveInteger } from "../../../shared/src/codecs/types/positiveInteger";
import { required } from "../../../shared/src/codecs/types/required";
import { union } from "../../../shared/src/codecs/types/union";
import { uuid } from "../../../shared/src/codecs/types/uuid";

export const CasesDayViewWeekCountsDay = required({
    date: date(),
    tasks_count: positiveInteger(),
    roadblocks_count: positiveInteger(),
});
export type TCasesDayViewWeekCountsDay = TTypeOfCodec<typeof CasesDayViewWeekCountsDay>;

export const CasesDayViewWeekCountsForm = form(
    required({
        assigned_to: union([nullCodec(), uuid()]),
        sail_homes_listing_only: boolean(),
    }),
    required({
        days: array(CasesDayViewWeekCountsDay),
        overdue: required({
            reschedulable_tasks_count: positiveInteger(),
            key_dates_count: positiveInteger(),
            roadblocks_count: positiveInteger(),
        }),
        cleared_today: required({
            tasks_count: positiveInteger(),
            roadblocks_count: positiveInteger(),
        }),
    }),
);
export type TCasesDayViewWeekCountsFormCodec = typeof CasesDayViewWeekCountsForm;
export type TCasesDayViewWeekCountsForm = TTypeOfCodec<TCasesDayViewWeekCountsFormCodec>;

export const CasesDayViewBulkRescheduleMode = union([
    required({
        type: literal("to_date"),
        assigned_to: union([nullCodec(), uuid()]),
        date: date(),
        sail_homes_listing_only: boolean(),
    }),
    required({
        type: literal("spread"),
        assigned_to: union([nullCodec(), uuid()]),
        sail_homes_listing_only: boolean(),
    }),
    required({
        type: literal("explicit"),
        items: array(required({
            id: uuid(),
            deferred_date: union([nullCodec(), date()]),
        })),
    }),
]);
export type TCasesDayViewBulkRescheduleMode = TTypeOfCodec<typeof CasesDayViewBulkRescheduleMode>;

export const CasesDayViewBulkRescheduleUpdatedItem = required({
    id: uuid(),
    previous_date: union([nullCodec(), date()]),
    new_date: union([nullCodec(), date()]),
});
export type TCasesDayViewBulkRescheduleUpdatedItem = TTypeOfCodec<typeof CasesDayViewBulkRescheduleUpdatedItem>;

export const CasesDayViewBulkAwaitMode = union([
    required({
        type: literal("spread"),
        assigned_to: union([nullCodec(), uuid()]),
        sail_homes_listing_only: boolean(),
    }),
    required({
        type: literal("to_date"),
        assigned_to: union([nullCodec(), uuid()]),
        sail_homes_listing_only: boolean(),
        date: date(),
    }),
    required({
        type: literal("undo"),
        block_ids: array(uuid()),
    }),
]);
export type TCasesDayViewBulkAwaitMode = TTypeOfCodec<typeof CasesDayViewBulkAwaitMode>;

export const CasesDayViewBulkAwaitForm = form(
    required({
        mode: CasesDayViewBulkAwaitMode,
    }),
    required({
        created_block_ids: array(uuid()),
        affected_roadblock_count: positiveInteger(),
    }),
);
export type TCasesDayViewBulkAwaitFormCodec = typeof CasesDayViewBulkAwaitForm;
export type TCasesDayViewBulkAwaitForm = TTypeOfCodec<TCasesDayViewBulkAwaitFormCodec>;

export const CasesDayViewBulkRescheduleForm = form(
    required({
        mode: CasesDayViewBulkRescheduleMode,
    }),
    required({
        updated: array(CasesDayViewBulkRescheduleUpdatedItem),
    }),
);
export type TCasesDayViewBulkRescheduleFormCodec = typeof CasesDayViewBulkRescheduleForm;
export type TCasesDayViewBulkRescheduleForm = TTypeOfCodec<TCasesDayViewBulkRescheduleFormCodec>;
